import httpClient from './httpClient';
import { NOTIFICATIONS, NOTIFICATIONS_UNREAD_COUNT } from '../constants/apiRouteConstants';

const NotificationService = {
  async listMyNotifications(page = 1, limit = 20) {
    const { data } = await httpClient.get(NOTIFICATIONS, {
      params: { page, limit }
    });
    return data;
  },

  async getUnreadCount() {
    const { data } = await httpClient.get(NOTIFICATIONS_UNREAD_COUNT);
    return data;
  },

  async markAsRead(id) {
    const { data } = await httpClient.patch(`${NOTIFICATIONS}/${id}/read`);
    return data;
  },

  async markAllAsRead() {
    const { data } = await httpClient.patch(`${NOTIFICATIONS}/read-all`);
    return data;
  }
};

export default NotificationService;
